<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>We only collect and store the following information:</p>
    <ul class="list-disc list-inside">
      <li>Email address: Provided voluntarily during account creation or login.</li>
      <li>Technical data: A secure authentication token (JWT) stored in a cookie for login purposes.</li>
      <li>Local storage data: Site configuration preferences (such as theme, layout, or other settings). Stored locally on your device and never sent to our servers.</li>
    </ul>
    <p>We do not collect any other personal data such as names, phone numbers, or tracking information.</p>
  </div>
</template>